<template>
  <div>
    <v-dialog scrollable v-model="show" max-width="500px">
      <v-card>
        <v-card-title>انتخاب دسته بندی</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="selection-controls" style="height: 400px">
          <v-checkbox
            color="success"
            v-for="item in category"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></v-checkbox>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click.stop="show = false">
            لغو
          </v-btn>
          <v-btn color="success darken-1" text @click.stop="show = false">
            انتخاب
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--  -->
    <v-dialog v-model="show2" max-width="500px">
      <v-card>
        <v-card-title>مرتب سازی</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 400px">
          <v-checkbox
            color="success"
            v-for="item in sort"
            :key="item.id"
            :label="item.label"
            :value="item.value"
          ></v-checkbox>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="grey darken-1" text @click.stop="show2 = false">
            لغو
          </v-btn>
          <v-btn color="success darken-1" text @click.stop="show2 = false">
            انتخاب
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["visible", "visible2"],
  computed: {
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
    show2: {
      get() {
        return this.visible2;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  data() {
    return {
      dialog: false,
      dialog2: false,
      category: [
        {
          id: 1,
          label: "پوشاک",
          value: "Clothing",
          icon: "mdi-view-dashboard",
        },
        {
          id: 2,
          label: "غذا و رستوران",
          value: "Food and restaurant",
        },
        {
          id: 3,
          label: "لوازم خانگی",
          value: "Home Appliances",
        },
        {
          id: 4,
          label: "دکوراسیون",
          value: "decoration",
        },
        {
          id: 5,
          label: "دیجیتال",
          value: "digital",
        },
        {
          id: 6,
          label: "آرایشی و بهداشتی",
          value: "Cosmetics",
        },
        {
          id: 7,
          label: "سفر و گردشگری",
          value: "Travel and tourism",
        },
        {
          id: 8,
          label: "زیورالات",
          value: "Ornaments",
        },
        {
          id: 9,
          label: "تفریحی و ورزشی",
          value: "Recreation and sports",
        },
        {
          id: 10,
          label: "ساختمان و تاسیسات",
          value: "Buildings and facilities",
        },
        {
          id: 11,
          label: "خدمات",
          value: "Services",
        },
      ],
      sort: [
        {
          id: 1,
          label: "مرتبط ترین",
        },
        {
          id: 2,
          label: "بالاترین رتبه",
        },
        {
          id: 3,
          label: "جدیدترین",
        },
        {
          id: 4,
          label: "بیشترین بازدید",
        },
        {
          id: 5,
          label: "بالاترین امتیاز",
        },
        {
          id: 6,
          label: "نزدیک ترین",
        },
      ],
    };
  },
};
</script>

<style>
.selection-controls {
  padding-top: 4px !important;
}
</style>